export default function UsersIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="9"
          cy="12.375"
          rx="4.5"
          ry="1.875"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <circle
          cx="9"
          cy="6"
          r="2.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M5.22852 9.75098C4.24444 10.199 3.51583 10.8171 3.18945 11.5273C3.07813 11.5615 2.97353 11.5971 2.87695 11.6357C2.58994 11.7505 2.40749 11.8683 2.30957 11.9609C2.29466 11.975 2.28553 11.9896 2.27637 12C2.28553 12.0104 2.29466 12.025 2.30957 12.0391C2.40749 12.1317 2.58994 12.2495 2.87695 12.3643C2.91678 12.3802 2.95857 12.394 3.00098 12.4092C3.01228 13.05 3.3412 13.6473 3.90332 14.1553C3.31511 14.0726 2.7752 13.9392 2.31934 13.7568C1.92792 13.6002 1.56078 13.3951 1.2793 13.1289C0.996109 12.8611 0.75 12.4798 0.75 12C0.75 11.5202 0.996109 11.1389 1.2793 10.8711C1.56078 10.6049 1.92792 10.3998 2.31934 10.2432C3.1016 9.93026 4.13006 9.75327 5.22852 9.75098Z"
          fill="currentColor"
        />
        <path
          d="M12.7715 9.75098C13.8699 9.75327 14.8984 9.93026 15.6807 10.2432C16.0721 10.3998 16.4392 10.6049 16.7207 10.8711C17.0039 11.1389 17.25 11.5202 17.25 12C17.25 12.4798 17.0039 12.8611 16.7207 13.1289C16.4392 13.3951 16.0721 13.6002 15.6807 13.7568C15.2245 13.9393 14.6843 14.0727 14.0957 14.1553C14.6581 13.6472 14.9867 13.0502 14.998 12.4092C15.0408 12.3939 15.0829 12.3803 15.123 12.3643C15.4101 12.2495 15.5925 12.1317 15.6904 12.0391C15.7051 12.0252 15.7136 12.0103 15.7227 12C15.7136 11.9897 15.7051 11.9748 15.6904 11.9609C15.5925 11.8683 15.4101 11.7505 15.123 11.6357C15.0262 11.597 14.9212 11.5616 14.8096 11.5273C14.4831 10.8173 13.7554 10.1989 12.7715 9.75098Z"
          fill="currentColor"
        />
        <path
          d="M12.75 4.5C13.9926 4.5 15 5.50736 15 6.75C15 7.99264 13.9926 9 12.75 9C12.3344 9 11.9464 8.88499 11.6123 8.68848C11.9737 8.33729 12.2649 7.91468 12.4619 7.44238C12.5506 7.47934 12.6479 7.5 12.75 7.5C13.1642 7.5 13.5 7.16421 13.5 6.75C13.5 6.33579 13.1642 6 12.75 6C12.75 5.47529 12.6419 4.9759 12.4473 4.52246C12.5464 4.50912 12.6472 4.5 12.75 4.5Z"
          fill="currentColor"
        />
        <path
          d="M5.25 4.5C5.35243 4.5 5.45295 4.5092 5.55176 4.52246C5.35725 4.97581 5.25 5.47543 5.25 6C4.83579 6 4.5 6.33579 4.5 6.75C4.5 7.16421 4.83579 7.5 5.25 7.5C5.3518 7.5 5.44861 7.47912 5.53711 7.44238C5.73412 7.91482 6.02625 8.33721 6.3877 8.68848C6.05359 8.88499 5.66564 9 5.25 9C4.00736 9 3 7.99264 3 6.75C3 5.50736 4.00736 4.5 5.25 4.5Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
